import React, { useState, useEffect } from "react";
import { 
  FaCarAlt, FaCalendarAlt, FaBell, FaHistory, FaMobile, FaShieldAlt,
  FaWrench, FaMapMarkerAlt, FaClock, FaUser, FaHeart, FaStars,
  FaCheckCircle, FaArrowRight, FaPlay, FaStar
} from "react-icons/fa";
import { SignInButton } from "@clerk/clerk-react";
import revvlyLogo from "@/img/revvly.png";

const LandingB2C = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isVisible, setIsVisible] = useState({});
  const [particles, setParticles] = useState([]);
  const [tools, setTools] = useState([]);

  // Función para manejar login con tipo de usuario cliente
  const handleClienteLogin = () => {
    // Guardar tipo de usuario en localStorage
    localStorage.setItem('revvly_user_type', 'cliente');
  };

  // Inicializar herramientas con movimiento y rebote
  useEffect(() => {
    const initialTools = [
      { 
        id: 1, 
        x: Math.random() * (window.innerWidth - 120), 
        y: Math.random() * (window.innerHeight - 120), 
        vx: (Math.random() - 0.5) * 1.2, 
        vy: (Math.random() - 0.5) * 1.2, 
        size: 120, 
        icon: 'gear',
        color: 'text-blue-400', 
        opacity: 8,
        rotation: 0,
        rotationSpeed: (Math.random() - 0.5) * 2
      },
      { 
        id: 2, 
        x: Math.random() * (window.innerWidth - 100), 
        y: Math.random() * (window.innerHeight - 100), 
        vx: (Math.random() - 0.5) * 1.0, 
        vy: (Math.random() - 0.5) * 1.0, 
        size: 100, 
        icon: 'wheel',
        color: 'text-indigo-400', 
        opacity: 10,
        rotation: 0,
        rotationSpeed: (Math.random() - 0.5) * 3
      },
      { 
        id: 3, 
        x: Math.random() * (window.innerWidth - 90), 
        y: Math.random() * (window.innerHeight - 90), 
        vx: (Math.random() - 0.5) * 1.4, 
        vy: (Math.random() - 0.5) * 1.4, 
        size: 90, 
        icon: 'oil',
        color: 'text-cyan-400', 
        opacity: 6,
        rotation: 0,
        rotationSpeed: (Math.random() - 0.5) * 2.5
      },
      { 
        id: 4, 
        x: Math.random() * (window.innerWidth - 80), 
        y: Math.random() * (window.innerHeight - 80), 
        vx: (Math.random() - 0.5) * 1.1, 
        vy: (Math.random() - 0.5) * 1.1, 
        size: 80, 
        icon: 'car',
        color: 'text-green-400', 
        opacity: 8,
        rotation: 0,
        rotationSpeed: (Math.random() - 0.5) * 1.8
      }
    ];
    setTools(initialTools);
  }, []);

  // Animación de herramientas con movimiento y rebote
  useEffect(() => {
    const animateTools = () => {
      setTools(prevTools => 
        prevTools.map(tool => {
          let newX = tool.x + tool.vx;
          let newY = tool.y + tool.vy;
          let newVx = tool.vx;
          let newVy = tool.vy;
          let newRotation = tool.rotation + tool.rotationSpeed;

          // Rebote en bordes horizontales
          if (newX <= 0 || newX >= window.innerWidth - tool.size) {
            newVx = -newVx;
            newX = newX <= 0 ? 0 : window.innerWidth - tool.size;
          }

          // Rebote en bordes verticales
          if (newY <= 0 || newY >= window.innerHeight - tool.size) {
            newVy = -newVy;
            newY = newY <= 0 ? 0 : window.innerHeight - tool.size;
          }

          return {
            ...tool,
            x: newX,
            y: newY,
            vx: newVx,
            vy: newVy,
            rotation: newRotation
          };
        })
      );
    };

    const interval = setInterval(animateTools, 16); // 60fps
    return () => clearInterval(interval);
  }, []);

  // Función para scroll suave
  const smoothScrollTo = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  // Inicializar partículas con rebote
  useEffect(() => {
    const initialParticles = [
      { id: 1, x: Math.random() * window.innerWidth, y: Math.random() * window.innerHeight, vx: (Math.random() - 0.5) * 2, vy: (Math.random() - 0.5) * 2, size: 3, color: 'bg-blue-400' },
      { id: 2, x: Math.random() * window.innerWidth, y: Math.random() * window.innerHeight, vx: (Math.random() - 0.5) * 2, vy: (Math.random() - 0.5) * 2, size: 4, color: 'bg-cyan-400' },
      { id: 3, x: Math.random() * window.innerWidth, y: Math.random() * window.innerHeight, vx: (Math.random() - 0.5) * 2, vy: (Math.random() - 0.5) * 2, size: 2, color: 'bg-indigo-400' },
      { id: 4, x: Math.random() * window.innerWidth, y: Math.random() * window.innerHeight, vx: (Math.random() - 0.5) * 2, vy: (Math.random() - 0.5) * 2, size: 5, color: 'bg-purple-400' },
      { id: 5, x: Math.random() * window.innerWidth, y: Math.random() * window.innerHeight, vx: (Math.random() - 0.5) * 2, vy: (Math.random() - 0.5) * 2, size: 3, color: 'bg-green-400' },
      { id: 6, x: Math.random() * window.innerWidth, y: Math.random() * window.innerHeight, vx: (Math.random() - 0.5) * 2, vy: (Math.random() - 0.5) * 2, size: 4, color: 'bg-pink-400' },
      { id: 7, x: Math.random() * window.innerWidth, y: Math.random() * window.innerHeight, vx: (Math.random() - 0.5) * 2, vy: (Math.random() - 0.5) * 2, size: 3, color: 'bg-yellow-400' },
      { id: 8, x: Math.random() * window.innerWidth, y: Math.random() * window.innerHeight, vx: (Math.random() - 0.5) * 2, vy: (Math.random() - 0.5) * 2, size: 2, color: 'bg-orange-400' }
    ];
    setParticles(initialParticles);
  }, []);

  // Animación de partículas con rebote
  useEffect(() => {
    const animateParticles = () => {
      setParticles(prevParticles => 
        prevParticles.map(particle => {
          let newX = particle.x + particle.vx;
          let newY = particle.y + particle.vy;
          let newVx = particle.vx;
          let newVy = particle.vy;

          // Rebote en bordes horizontales
          if (newX <= 0 || newX >= window.innerWidth - particle.size * 4) {
            newVx = -newVx;
            newX = newX <= 0 ? 0 : window.innerWidth - particle.size * 4;
          }

          // Rebote en bordes verticales
          if (newY <= 0 || newY >= window.innerHeight - particle.size * 4) {
            newVy = -newVy;
            newY = newY <= 0 ? 0 : window.innerHeight - particle.size * 4;
          }

          return {
            ...particle,
            x: newX,
            y: newY,
            vx: newVx,
            vy: newVy
          };
        })
      );
    };

    const interval = setInterval(animateParticles, 16); // ~60fps
    return () => clearInterval(interval);
  }, []);

  // Animación de entrada progresiva
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible({ hero: true });
    }, 100);

    const timer2 = setTimeout(() => {
      setIsVisible(prev => ({ ...prev, features: true }));
    }, 300);

    const timer3 = setTimeout(() => {
      setIsVisible(prev => ({ ...prev, testimonials: true }));
    }, 500);

    return () => {
      clearTimeout(timer);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, []);

  // Rotar testimonios automáticamente
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // Features para clientes
  const features = [
    {
      icon: <FaCalendarAlt className="text-4xl" />,
      title: "Agenda tus Citas Online",
      description: "Reserva servicios de mantenimiento de manera fácil y rápida, las 24 horas del día.",
      color: "from-blue-500 to-cyan-500",
      benefit: "Sin llamadas ni esperas"
    },
    {
      icon: <FaHistory className="text-4xl" />,
      title: "Historial Completo",
      description: "Accede al historial completo de servicios, repuestos utilizados y garantías de tu vehículo.",
      color: "from-green-500 to-emerald-500",
      benefit: "Todo en un solo lugar"
    },
    {
      icon: <FaBell className="text-4xl" />,
      title: "Recordatorios Inteligentes",
      description: "Recibe notificaciones automáticas sobre próximos mantenimientos y vencimiento de garantías.",
      color: "from-purple-500 to-violet-500",
      benefit: "Nunca olvides un servicio"
    },
    {
      icon: <FaShieldAlt className="text-4xl" />,
      title: "Garantías Digitales",
      description: "Todas tus garantías disponibles digitalmente, sin papeles que se pierdan.",
      color: "from-orange-500 to-red-500",
      benefit: "Seguridad total"
    },
    {
      icon: <FaMobile className="text-4xl" />,
      title: "Acceso Móvil",
      description: "Gestiona todo desde tu celular o computador, donde y cuando necesites.",
      color: "from-pink-500 to-rose-500",
      benefit: "Siempre disponible"
    },
    {
      icon: <FaMapMarkerAlt className="text-4xl" />,
      title: "Encuentra tu Taller",
      description: "Localiza talleres cercanos afiliados a Revvly y compara servicios fácilmente.",
      color: "from-indigo-500 to-blue-500",
      benefit: "Red de talleres confiables"
    }
  ];

  // Testimonios de clientes
  const testimonials = [
    {
      name: "María González",
      vehicle: "Honda Civic 2020",
      text: "Revvly me cambió la vida. Ahora puedo agendar el mantenimiento de mi auto desde el trabajo y tengo todo el historial organizado.",
      rating: 5,
      avatar: "👩‍💼"
    },
    {
      name: "Carlos Mendoza",
      vehicle: "Toyota Corolla 2019",
      text: "Los recordatorios automáticos son geniales. Ya no se me olvida cambiar el aceite y mi auto siempre está en perfecto estado.",
      rating: 5,
      avatar: "👨‍💻"
    },
    {
      name: "Ana Ruiz",
      vehicle: "Nissan Sentra 2021",
      text: "El historial digital es increíble. Cuando vendí mi auto anterior, pude mostrar todos los mantenimientos realizados.",
      rating: 5,
      avatar: "👩‍🎓"
    }
  ];

  // Beneficios clave
  const benefits = [
    {
      icon: <FaClock className="text-2xl text-blue-400" />,
      title: "Ahorra Tiempo",
      description: "Agenda en segundos, sin llamadas"
    },
    {
      icon: <FaHeart className="text-2xl text-red-400" />,
      title: "Cuida tu Auto",
      description: "Recordatorios para mantenimientos"
    },
    {
      icon: <FaShieldAlt className="text-2xl text-green-400" />,
      title: "Total Seguridad",
      description: "Garantías digitales seguras"
    },
    {
      icon: <FaUser className="text-2xl text-purple-400" />,
      title: "Fácil de Usar",
      description: "Interfaz simple e intuitiva"
    }
  ];

  // Función para renderizar íconos de herramientas
  const renderToolIcon = (iconType) => {
    const iconPaths = {
      wrench: "M22.7,19l-9.1-9.1c0.9-2.3,0.4-5-1.5-6.9c-2-2-5-2.4-7.4-1.3L9,6.1L6.1,9l-4.4-4.4c-1.1,2.4-0.7,5.4,1.3,7.4c1.9,1.9,4.6,2.4,6.9,1.5l9.1,9.1c0.4,0.4,1,0.4,1.4,0l1.3-1.3C21.1,20.1,21.1,19.4,22.7,19z",
      car: "M5,11L6.5,6.5H17.5L19,11M17.5,16A1.5,1.5 0 0,1 16,14.5A1.5,1.5 0 0,1 17.5,13A1.5,1.5 0 0,1 19,14.5A1.5,1.5 0 0,1 17.5,16M6.5,16A1.5,1.5 0 0,1 5,14.5A1.5,1.5 0 0,1 6.5,13A1.5,1.5 0 0,1 8,14.5A1.5,1.5 0 0,1 6.5,16M18.92,6C18.72,5.42 18.16,5 17.5,5H6.5C5.84,5 5.28,5.42 5.08,6L3,12V20A1,1 0 0,0 4,21H5A1,1 0 0,0 6,20V19H18V20A1,1 0 0,0 19,21H20A1,1 0 0,0 21,20V12L18.92,6Z",
      gear: "M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.22,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.22,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.68 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z",
      wheel: "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,6A6,6 0 0,0 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12A6,6 0 0,0 12,6M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8Z",
      oil: "M6,2V4H7V6H6A2,2 0 0,0 4,8V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8A2,2 0 0,0 18,6H17V4H18V2H6M8,4H16V6H8V4M6,8H18V20H6V8M8,10V18H16V10H8Z",
      key: "M7,6A1,1 0 0,0 6,7V9H4V7A3,3 0 0,1 7,4A3,3 0 0,1 10,7V8H12L14,6H16L18,8V10L16,12H12V14H10V12H8V10H6V8H7V7A1,1 0 0,0 7,6Z",
      battery: "M16.67,4H15V2H9V4H7.33A1.33,1.33 0 0,0 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67A1.33,1.33 0 0,0 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z"
    };
    return iconPaths[iconType] || iconPaths.wrench;
  };

  return (
    <div className="bg-gradient-to-br from-slate-900 via-blue-900 to-indigo-900 text-white min-h-screen overflow-hidden">
      {/* Efectos de fondo animados - Herramientas flotantes que se mueven y rebotan */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        {/* Herramientas dinámicas con movimiento y rebote */}
        {tools.map(tool => (
          <div 
            key={tool.id}
            className="absolute"
            style={{
              left: `${tool.x}px`,
              top: `${tool.y}px`,
              width: `${tool.size}px`,
              height: `${tool.size}px`,
              opacity: tool.opacity / 100,
              transform: `rotate(${tool.rotation}deg)`
            }}
          >
            <svg 
              className={`w-full h-full ${tool.color}`} 
              fill="currentColor" 
              viewBox="0 0 24 24"
            >
              <path d={renderToolIcon(tool.icon)}/>
            </svg>
          </div>
        ))}

        {/* Partículas con rebote que se mueven por la pantalla */}
        {particles.map(particle => (
          <div
            key={particle.id}
            className="absolute opacity-60 blur-sm transition-all duration-75 ease-linear"
            style={{
              left: `${particle.x}px`,
              top: `${particle.y}px`,
              width: `${particle.size * 4}px`,
              height: `${particle.size * 4}px`,
            }}
          >
            <div className={`w-full h-full ${particle.color} rounded-full relative shadow-lg`}>
              <div className="absolute inset-0 bg-white rounded-full transform scale-25 opacity-40"></div>
            </div>
          </div>
        ))}
      </div>

      <div className="relative z-10">
        {/* Header */}
        <header className="relative">
          <div className="absolute inset-0 h-32 bg-gradient-to-b from-black via-gray-900 to-transparent opacity-80"></div>
          <div className="relative container mx-auto px-6 py-8">
            <nav className="flex justify-between items-center">
              <div className="flex items-center space-x-3">
                <img src={revvlyLogo} alt="Revvly" className="h-10" />
              </div>
              <div className="hidden md:flex space-x-8">
                <button onClick={() => smoothScrollTo('beneficios')} className="hover:text-blue-400 transition-colors duration-300">Beneficios</button>
                <button onClick={() => smoothScrollTo('como-funciona')} className="hover:text-blue-400 transition-colors duration-300">Cómo Funciona</button>
                <button onClick={() => smoothScrollTo('testimonios')} className="hover:text-blue-400 transition-colors duration-300">Testimonios</button>
              </div>
              <SignInButton mode="modal">
                <button 
                  onClick={handleClienteLogin}
                  className="bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 px-6 py-2 rounded-full font-semibold transition-all duration-300 transform hover:scale-105"
                >
                  Acceder
                </button>
              </SignInButton>
            </nav>
          </div>
        </header>

        {/* Hero Section */}
        <section className={`container mx-auto px-6 py-20 text-center transition-all duration-1000 ${isVisible.hero ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="max-w-5xl mx-auto">
            <div className="mb-8">
              <span className="inline-block bg-gradient-to-r from-blue-500 to-indigo-600 px-4 py-2 rounded-full text-sm font-semibold mb-6">
                🚗 Gestión Inteligente de Vehículos
              </span>
            </div>

            <h1 className="text-5xl md:text-7xl font-bold mb-8 leading-tight" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              <span className="text-white">Cuida tu</span>
              <br />
              <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
                Vehículo
              </span>
              <br />
              <span className="text-white">con</span>
              <div className="flex justify-center items-center mt-4">
                <div className="relative">
                  {/* Resplandor sutil azul en la parte inferior */}
                  <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-2 w-full h-1/2 bg-cyan-400 blur-3xl opacity-40 rounded-full"></div>
                  <img 
                    src={revvlyLogo} 
                    alt="Revvly" 
                    className="relative h-16 md:h-20" 
                    style={{
                      filter: 'brightness(1.4) contrast(1.3) saturate(1.2) drop-shadow(0 0 15px rgba(6, 182, 212, 0.8)) drop-shadow(0 0 30px rgba(255, 255, 255, 0.3))'
                    }}
                  />
                </div>
              </div>
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto" style={{ fontFamily: "'Inter', sans-serif" }}>
              La forma más fácil de gestionar el mantenimiento de tu vehículo. 
              <span className="text-blue-400 font-semibold"> Agenda citas, recibe recordatorios y mantén todo organizado</span>
            </p>

            <div className="flex flex-col md:flex-row gap-6 justify-center items-center mb-16">
              <SignInButton mode="modal">
                <button 
                  onClick={handleClienteLogin}
                  className="bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 px-8 py-4 rounded-full text-xl font-bold transition-all duration-300 transform hover:scale-105 hover:shadow-2xl flex items-center space-x-2"
                >
                  <FaCarAlt />
                  <span>Gestionar Mi Auto</span>
                  <FaArrowRight />
                </button>
              </SignInButton>
              
              <button className="border-2 border-blue-400 hover:bg-blue-400 hover:text-gray-900 px-8 py-4 rounded-full text-xl font-bold transition-all duration-300 transform hover:scale-105 flex items-center space-x-2">
                <FaPlay />
                <span>Ver Cómo Funciona</span>
              </button>
            </div>

            {/* Beneficios rápidos */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="bg-white bg-opacity-5 backdrop-blur-sm rounded-xl p-4 text-center border border-gray-800 hover:border-blue-500 transition-all duration-300 hover:bg-opacity-10">
                  <div className="mb-2 flex justify-center">{benefit.icon}</div>
                  <h3 className="font-semibold mb-1 text-sm">{benefit.title}</h3>
                  <p className="text-xs text-gray-400">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section id="beneficios" className={`py-20 transition-all duration-1000 delay-300 ${isVisible.features ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
                  Todo lo que Necesitas
                </span>
              </h2>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                Herramientas diseñadas para hacer tu vida más fácil
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {features.map((feature, index) => (
                <div 
                  key={index}
                  className="group relative bg-white bg-opacity-5 backdrop-blur-sm rounded-2xl overflow-hidden border border-gray-800 hover:border-blue-500 transition-all duration-300 transform hover:scale-102 hover:shadow-xl"
                >
                  {/* Gradient Overlay */}
                  <div className={`absolute inset-0 bg-gradient-to-br ${feature.color} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}></div>
                  
                  {/* Espacio para imagen */}
                  <div className="relative h-40 bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center">
                    <div className="absolute inset-0 bg-gradient-to-br from-blue-600/20 to-cyan-600/20"></div>
                    <div className="relative z-10 text-center">
                      <div className={`inline-flex p-3 rounded-xl bg-gradient-to-br ${feature.color} mb-2`}>
                        {feature.icon}
                      </div>
                      <div className="text-xs text-gray-400 font-medium">
                        {feature.benefit}
                      </div>
                    </div>
                    {/* Placeholder para imagen futura */}
                    <div className="absolute top-2 right-2 text-xs text-gray-500 bg-gray-800 px-2 py-1 rounded">
                      📸 Imagen próximamente
                    </div>
                  </div>
                  
                  <div className="relative z-10 p-5">
                    <h3 className="text-lg font-bold mb-2 text-white">{feature.title}</h3>
                    <p className="text-sm text-gray-400 leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Cómo Funciona */}
        <section id="como-funciona" className="py-20">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                <span className="bg-gradient-to-r from-green-400 to-blue-400 bg-clip-text text-transparent">
                  Súper Fácil de Usar
                </span>
              </h2>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                En solo 3 pasos tienes todo configurado
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center text-2xl font-bold mb-6 mx-auto">
                  1
                </div>
                <h3 className="text-2xl font-bold mb-4">Regístrate</h3>
                <p className="text-gray-300">Crea tu cuenta gratis con Google en segundos</p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-full flex items-center justify-center text-2xl font-bold mb-6 mx-auto">
                  2
                </div>
                <h3 className="text-2xl font-bold mb-4">Agrega tu Auto</h3>
                <p className="text-gray-300">Ingresa los datos de tu vehículo y conecta con tu taller</p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-r from-purple-500 to-pink-600 rounded-full flex items-center justify-center text-2xl font-bold mb-6 mx-auto">
                  3
                </div>
                <h3 className="text-2xl font-bold mb-4">¡Listo!</h3>
                <p className="text-gray-300">Agenda citas y recibe recordatorios automáticamente</p>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section id="testimonios" className={`py-20 transition-all duration-1000 delay-500 ${isVisible.testimonials ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                <span className="bg-gradient-to-r from-yellow-400 to-orange-400 bg-clip-text text-transparent">
                  Clientes Felices
                </span>
              </h2>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                Más de 10,000 personas ya cuidan mejor sus vehículos con Revvly
              </p>
            </div>

            <div className="max-w-4xl mx-auto">
              <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-3xl p-8 md:p-12 text-center">
                <div className="text-6xl mb-6">{testimonials[currentTestimonial].avatar}</div>
                
                <div className="flex justify-center mb-6">
                  {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                    <FaStar key={i} className="text-yellow-400 text-xl" />
                  ))}
                </div>
                
                <blockquote className="text-xl md:text-2xl text-gray-200 mb-6 italic">
                  "{testimonials[currentTestimonial].text}"
                </blockquote>
                
                <div className="font-bold text-lg">{testimonials[currentTestimonial].name}</div>
                <div className="text-gray-400">{testimonials[currentTestimonial].vehicle}</div>
              </div>

              {/* Indicadores */}
              <div className="flex justify-center mt-8 space-x-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentTestimonial(index)}
                    className={`w-3 h-3 rounded-full transition-all duration-300 ${
                      index === currentTestimonial ? 'bg-blue-400' : 'bg-gray-600'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-20 text-center">
          <div className="container mx-auto px-6">
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-3xl p-12 mx-auto max-w-4xl">
              <h2 className="text-4xl font-bold mb-6">¿Listo para Cuidar Mejor tu Auto?</h2>
              <p className="text-xl mb-8 opacity-90">
                Únete a miles de personas que ya tienen el control total de sus vehículos
              </p>
              <SignInButton mode="modal">
                <button 
                  onClick={handleClienteLogin}
                  className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-4 rounded-full text-xl font-bold transition-all duration-300 transform hover:scale-105 flex items-center space-x-2 mx-auto"
                >
                  <FaCarAlt />
                  <span>Comenzar Gratis</span>
                  <FaCheckCircle />
                </button>
              </SignInButton>
              <p className="text-sm mt-4 opacity-75">100% gratis • Sin tarjeta de crédito</p>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="relative py-12 border-t border-gray-800">
          <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-black via-gray-900/80 to-transparent"></div>
          <div className="relative container mx-auto px-6 text-center">
            <div className="flex justify-center items-center mb-4">
              <img src={revvlyLogo} alt="Revvly" className="h-8 mr-2" />
              <span className="text-gray-400 text-sm">Powered by Aitomata</span>
            </div>
            <p className="text-gray-500">© 2025 Revvly. Todos los derechos reservados.</p>
          </div>
        </footer>
      </div>

      {/* Styles para animaciones personalizadas */}
      <style jsx>{`
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-25px) rotate(15deg); }
        }
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes spin-reverse-slow {
          from { transform: rotate(360deg); }
          to { transform: rotate(0deg); }
        }
        .animate-float {
          animation: float 10s ease-in-out infinite;
        }
        .animate-spin-slow {
          animation: spin-slow 15s linear infinite;
        }
        .animate-spin-reverse-slow {
          animation: spin-reverse-slow 18s linear infinite;
        }
        @keyframes drift-1 {
          0% { transform: translate(-100px, 100vh) rotate(0deg); }
          100% { transform: translate(100vw, -100px) rotate(360deg); }
        }
        @keyframes drift-2 {
          0% { transform: translate(100vw, -100px) rotate(0deg); }
          100% { transform: translate(-100px, 100vh) rotate(-360deg); }
        }
        @keyframes drift-3 {
          0% { transform: translate(30vw, 100vh) rotate(0deg); }
          100% { transform: translate(70vw, -100px) rotate(720deg); }
        }
        @keyframes drift-4 {
          0% { transform: translate(-100px, 30vh) rotate(0deg); }
          100% { transform: translate(100vw, 70vh) rotate(-180deg); }
        }
        @keyframes drift-5 {
          0% { transform: translate(90vw, 100vh) rotate(0deg); }
          100% { transform: translate(10vw, -100px) rotate(540deg); }
        }
        @keyframes drift-6 {
          0% { transform: translate(10vw, -100px) rotate(0deg); }
          100% { transform: translate(90vw, 100vh) rotate(-270deg); }
        }
        .animate-drift-1 {
          animation: drift-1 40s linear infinite;
        }
        .animate-drift-2 {
          animation: drift-2 45s linear infinite 8s;
        }
        .animate-drift-3 {
          animation: drift-3 38s linear infinite 12s;
        }
        .animate-drift-4 {
          animation: drift-4 50s linear infinite 18s;
        }
        .animate-drift-5 {
          animation: drift-5 43s linear infinite 22s;
        }
        .animate-drift-6 {
          animation: drift-6 47s linear infinite 28s;
        }
        @keyframes drift-7 {
          0% { transform: translate(60vw, -100px) rotate(0deg); }
          100% { transform: translate(40vw, 100vh) rotate(450deg); }
        }
        @keyframes drift-8 {
          0% { transform: translate(-100px, 80vh) rotate(0deg); }
          100% { transform: translate(100vw, 20vh) rotate(-315deg); }
        }
        .animate-drift-7 {
          animation: drift-7 41s linear infinite 32s;
        }
        .animate-drift-8 {
          animation: drift-8 44s linear infinite 35s;
        }
      `}</style>
    </div>
  );
};

export default LandingB2C;